export class HistoryManager<T> {
  private history: T[] = [];
  private index = -1;
  private readonly maxHistory: number;

  constructor(maxHistory = 30) {
    this.maxHistory = maxHistory;
  }

  push(state: T): void {
    // If we are in the middle of history, cut off the future
    if (this.index < this.history.length - 1) {
      this.history = this.history.slice(0, this.index + 1);
    }

    this.history.push(state);
    this.index++;

    if (this.history.length > this.maxHistory) {
      this.history.shift();
      this.index--;
    }
  }

  undo(): T | null {
    if (this.canUndo()) {
      this.index--;
      return this.getCurrent();
    }
    return null;
  }

  redo(): T | null {
    if (this.canRedo()) {
      this.index++;
      return this.getCurrent();
    }
    return null;
  }

  getCurrent(): T | null {
    if (this.index >= 0 && this.index < this.history.length) {
      return this.history[this.index];
    }
    return null;
  }

  canUndo(): boolean {
    return this.index > 0;
  }

  canRedo(): boolean {
    return this.index < this.history.length - 1;
  }

  reset(): void {
    this.history = [];
    this.index = -1;
  }

  getHistoryLength(): number {
    return this.history.length;
  }
}
